import { useEffect, useState } from 'react'
import Api from 'services/api'

export default function Gdpr() {
    const [data, setData] = useState(null)
    useEffect(() => {
        const API = new Api()
        const getGDPR = async () => {
            const responseGql = await API.getGDPRdata()
            setData(responseGql.data.data.data.entry.componentsBuilder[0].html)
        }
        getGDPR()
    }, [])
    return (
        <div style={{ color: 'white', maxWidth: 1500, margin: 'auto' }}>
            <div dangerouslySetInnerHTML={{ __html: data }} />
        </div>
    )
}
